import request from '@/request'


export function matchdetail(params) {
  return request({
    url: '/datalive/v3/round/info',
    method: 'get',
    params
  })
}
export function collist(params) {
  return request({
    url: '/datalive/v3/roundCollect/list',
    method: 'get',
    params
  })
}
export function backlist(params) {
  return request({
    url: '/datalive/v3/roundScore/list',
    method: 'get',
    params
  })
}
export function getClubId(params) {
  return request({
    url: '/datalive/live/clubScore/existRound',
    method: 'get',
    params
  })
}
//赛季列表
export function getMatchs(params) {
  return request({
    url: '/datalive/v3/match/list',
    method: 'get',
    params
  })
}
//训赛列表
export function matchlist(params) {
  return request({
    url: '/datalive/v3/round/list',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/search.js